import { jsx } from 'panel';
import { FilterBarEl } from 'common/components/filter-bar';
import { TableEl } from 'common/components/table';
import { ToggleEl } from 'common/components/toggle';
export function template() {
  const {
    columns,
    customHeaderBarRenderer,
    getFilterSortedMenuSections,
    rowDetailsRenderer,
    selectedTab,
    tabs
  } = this.state;
  return jsx("div", {
    sel: '.filter-bar-table'
  }, !this.attr("hide-header") ? jsx("div", {
    sel: '.filter-bar-table-header'
  }, jsx("div", {
    sel: '.filter-bar-table-tabs'
  }, jsx(ToggleEl, {
    attrs: {
      elref: this.helpers.getTabsElRef(),
      size: "large",
      selected: selectedTab,
      theme: this.attr("tab-theme") || "tab-bar",
      'style-override': this.attr("tab-theme") ? null : ".mp-toggle-option { margin-left: 15px; }",
      options: tabs
    },
    on: {
      select: this.helpers.handleTabChange
    }
  }), jsx("slot", {
    attrs: {
      name: "actions"
    }
  })), jsx("div", {
    sel: '.filter-bar-table-header-bar'
  }, customHeaderBarRenderer ? customHeaderBarRenderer() : null)) : null, !this.attr("hide-filter-bar") ? jsx(FilterBarEl, {
    attrs: this.helpers.getBarAttrs(),
    on: {
      updateInput: this.helpers.handleFilterSearchChange,
      clickAction: this.helpers.handleClickAction,
      clearSelected: this.helpers.handleClearSelected,
      changeFilter: this.helpers.handleFilterSelectChange,
      applyFilter: this.helpers.handleApplyFilter,
      filterMenuChange: this.helpers.handleFilterMenuChange,
      filterSelectAll: this.helpers.filterSelectAll
    },
    hook: this.attr("sticky-titles") ? this.helpers.stickyElemHooks : {},
    props: {
      getFilterSortedMenuSections
    }
  }) : null, jsx(TableEl, {
    attrs: this.helpers.getTableAttrs(),
    props: {
      rows: this.helpers.getTableRows(),
      rowDetailsRenderer,
      columns
    },
    on: {
      selectionChange: this.helpers.handleSelectionChange,
      numResultsChange: this.helpers.handleTableResultsChange,
      rowDetailsVisibilityChange: this.helpers.handleRowDetailsVisibilityChange,
      rowClick: this.helpers.handleRowClick,
      cellClick: this.helpers.handleCellClick,
      sortChange: this.helpers.handleSortChange,
      columnMoved: this.helpers.handleColumnMoved
    }
  }));
}